import React from 'react';
import { Grid } from '@mui/material';
import { Box } from '@mui/material';
import ShabashNominations from './ShabashNominations';
import { useGetAllShabashNominationsQuery } from '../shabashApiSlice';
import SkeletonTable from '../../RnR/AdminRnR/SkeletonTable';

const AdminShabash = () => {
  const { data, isLoading, isError } = useGetAllShabashNominationsQuery();


  return (
    <Grid container gap={1.5}>
      <Grid item xl={12} md={12} sm={12}>
        <Box
          sx={{
            border: 1,
            backgroundColor: 'text.wb',
            borderRadius: '8px',
            borderColor: 'divider',
          }}
        >
          {isLoading ? <SkeletonTable /> : <ShabashNominations data={data.data} />}
        </Box>
      </Grid>
    </Grid>
  );
};

export default AdminShabash;
